export default "__VITE_ASSET__acbe741a__"